/*
 * 2026-media-big — viewport-gated autoplay for Shopify-hosted <video>.
 *
 * Only runs for sections whose merchant enabled "Autoplay (muted) when visible
 * in viewport"; those render <div class="media-big-2026__media" data-mb-autoplay-in-view="true">.
 * Plays the video (muted, inline) while it is on screen and pauses it when it
 * scrolls out of view. No effect on YouTube/Vimeo embeds or images.
 *
 * Loaded once per page (guarded), regardless of how many section instances opt in.
 */
(function () {
  'use strict';

  if (window.__mediaBig2026Autoplay) return;
  window.__mediaBig2026Autoplay = true;

  var SELECTOR = '.media-big-2026__media[data-mb-autoplay-in-view="true"] video.media-big-2026__video';

  // Re-evaluated on every play attempt so a mid-session OS toggle is respected.
  var reduceMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  function safePlay(video) {
    // Honor the OS "reduce motion" setting: don't auto-start. With controls shown the
    // user can still play manually; the poster frame stays visible otherwise.
    if (reduceMotion && reduceMotion.matches) return;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        /* Autoplay can still be rejected (e.g. reduced-data / power-save); ignore. */
      });
    }
  }

  function setup(video) {
    if (video.dataset.mbAutoplayBound === 'true') return;
    video.dataset.mbAutoplayBound = 'true';

    // Required for programmatic autoplay and to avoid iOS fullscreen takeover.
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');

    if (!('IntersectionObserver' in window)) {
      safePlay(video);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            safePlay(entry.target);
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(video);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Re-scan when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
